export const environment = {
  production: true,
  assetsPath: '/assets',
  apiUrl: 'https://backend.teti.netseven.it/',
};